
export default function ProblemSection() {
  const problems = [
    {
      icon: 'ri-user-search-line',
      title: '応募が全然来ない',
      description: '求人を出しても応募者が集まらず、慢性的な人手不足に悩んでいる',
      color: 'text-red-500'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: '採用コストが高すぎる',
      description: '求人広告費や人材紹介料が高額で、採用1名あたりのコストが経営を圧迫',
      color: 'text-orange-500'
    },
    {
      icon: 'ri-time-line',
      title: '採用に時間がかかる',
      description: '良い人材が見つからず、採用まで何ヶ月もかかってしまう',
      color: 'text-yellow-500'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-6">
            こんな<span className="text-red-500">採用課題</span>でお困りではありませんか？
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            運送業界の人手不足は深刻化しており、多くの企業が同じような課題を抱えています
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {problems.map((problem, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="text-center">
                <div className={`w-16 h-16 mx-auto mb-6 flex items-center justify-center rounded-full bg-gray-100 ${problem.color}`}>
                  <i className={`${problem.icon} text-3xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-4">{problem.title}</h3>
                <p className="text-gray-600 leading-relaxed">{problem.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <div className="bg-blue-600 text-white rounded-xl p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold mb-4">
              <i className="ri-lightbulb-line mr-2"></i>
              そんな課題を解決するのが「ドライバー集客」です
            </h3>
            <p className="text-lg">
              運送業界に特化した求人集客ノウハウで、あなたの採用を成功に導きます
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
